// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"c8ad2234","453":"05801d9b","961":"158f49a1"}[chunkId] + ".chunk.js";
};